module.exports = __webpack_public_path__ + "static/media/ca@2x.52bf9bbb.webp";